import { View, StyleSheet } from "react-native";
import PickerColorHex from "../../../components/PickerColorHex";
import { UploadImages } from "../../../components/UploadImages";
import { useCustomLogin } from "../useCustomLogin";
import {
  SectionCard,
  Field,
  FieldLabel,
  Row,
  Col,
} from "../../AdminPanel/Products/formStyles";

// Componentes definidos em escopo de módulo (identidade estável) para que
// UploadImages/PickerColorHex NÃO desmontem a cada re-render do formulário —
// o que fecharia o modal de cores e resetaria o estado de upload.
const InlineImage = ({ label, tooltip, fileType, last }) => (
  <View style={[styles.inlineField, last && { marginBottom: 0 }]}>
    <FieldLabel tooltip={tooltip}>{label}</FieldLabel>
    <UploadImages fileType={fileType} />
  </View>
);

const ColorField = ({ label, colorName, setColor, showKey, show, handleShowPicker }) => (
  <Field style={{ marginBottom: 0 }}>
    <FieldLabel>{label}</FieldLabel>
    <PickerColorHex
      colorName={colorName}
      props={{ color: colorName, onChange: setColor }}
      setShow={() => handleShowPicker(showKey, !show[showKey])}
      isShowPicker={show[showKey]}
      setChange={setColor}
    />
  </Field>
);

const FormCustomLogin = () => {
  const {
    backgroundColor,
    setBackgroundColor,
    textColor,
    setTextColor,
    backgroundButtonColor,
    setBackgroundButtonColor,
    textButtonColor,
    setTextButtonColor,
    show,
    handleShowPicker,
  } = useCustomLogin();

  return (
    <>
      <SectionCard
        title="Imagens"
        subtitle="Logo e imagem lateral exibidos na tela de login (web)."
      >
        <InlineImage
          label="Logo (PNG)"
          tooltip="Tamanho recomendado: 300x300px, limitado a 2MB. Apenas imagens .png são aceitas."
          fileType="logoAuth"
        />
        <InlineImage
          label="Imagem lateral (PNG)"
          tooltip="Aparece somente na versão web acessada pelo desktop. Tamanho recomendado: 980x1289px, limitado a 2MB. Apenas .png."
          fileType="imageAuth"
          last
        />
      </SectionCard>

      <SectionCard
        title="Cores"
        subtitle="Cores de fundo, textos e botões da tela de login."
      >
        <Row style={{ marginBottom: 18 }}>
          <Col>
            <ColorField
              label="Cor de fundo"
              colorName={backgroundColor}
              setColor={setBackgroundColor}
              showKey="showBackgroundColor"
              show={show}
              handleShowPicker={handleShowPicker}
            />
          </Col>
          <Col>
            <ColorField
              label="Cor dos textos"
              colorName={textColor}
              setColor={setTextColor}
              showKey="showTextColor"
              show={show}
              handleShowPicker={handleShowPicker}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ColorField
              label="Cor de fundo do botão"
              colorName={backgroundButtonColor}
              setColor={setBackgroundButtonColor}
              showKey="showBackgroundButtonColor"
              show={show}
              handleShowPicker={handleShowPicker}
            />
          </Col>
          <Col>
            <ColorField
              label="Cor do texto do botão"
              colorName={textButtonColor}
              setColor={setTextButtonColor}
              showKey="showTextButtonColor"
              show={show}
              handleShowPicker={handleShowPicker}
            />
          </Col>
        </Row>
      </SectionCard>
    </>
  );
};

const styles = StyleSheet.create({
  inlineField: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 16,
  },
});

export default FormCustomLogin;
